import React from "react";
// import PropTypes from 'prop-types';
import S from "../../../styles/components";

const Playhead = ({
  onSeek,
  progress = 0,
  isSentimentAnalyzerOn,
  isChatTextMedia,
}) => (
  <tbody>
    <tr>
      {/* <span style={{ padding: 0 }}></span> */}
      <th style={{ padding: 0, position: "relative" }}>
        <S.TimelinePlayhead
          width="100%"
          height="100%"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          onClick={isChatTextMedia ? null : onSeek}
          isSentimentAnalyzerOn={isSentimentAnalyzerOn}
          //   style={{backGround:'red'}}
        >
          <line
            vectorEffect="non-scaling-stroke"
            strokeWidth="1"
            stroke="rgba(0, 0, 0, 0.2)"
            style={{ shapeRendering: "crispEdges" }}
            y1="0"
            y2="100%"
            x1={`${progress}%`}
            x2={`${progress}%`}
          />
          <rect
            // width={`${progress}%`}
            width="100%"
            height="100%"
            opacity="0.00"
          />
        </S.TimelinePlayhead>
      </th>
    </tr>
  </tbody>
);

export default Playhead;
